/* Endless scroll for collection product lists.
   Appends next page's product cards as the visitor approaches the bottom;
   falls back to normal pagination links when JS is off. */
(function () {
  'use strict';
  var NAV_SEL = '.collection__pagination, .pagination';

  function init() {
    var root = document;
    var list = root.querySelector('product-list');
    var nav = root.querySelector(NAV_SEL);
    if (!list || !nav) return;
    if (list.dataset.endless === '1') return;
    list.dataset.endless = '1';
    var loading = false;

    function nextUrl() {
      var a = nav.querySelector('a[rel="next"]');
      if (!a) return null;
      try {
        var href = a.getAttribute('href') || '';
        if (!href) return null;
        return href.charAt(0) === '/' ? href : ('/' + href.replace(/^https?:\/\/[^/]+/, ''));
      } catch (e) { return null; }
    }

    function restoreReveal(el) {
      if (!el.querySelectorAll) return;
      var nodes = el.querySelectorAll('[data-reveal], .reveal-item, reveal-items > *');
      for (var i = 0; i < nodes.length; i++) {
        var n = nodes[i];
        if (n.classList) { n.classList.add('reveal-item--visible'); n.style.opacity = '1'; }
      }
    }

    function nearBottom() {
      var rect = list.getBoundingClientRect();
      return (rect.bottom - (window.innerHeight || 900)) < 640;
    }

    function tick(force) {
      if (loading || list.dataset.endless !== '1') return;
      if (!force && !nearBottom()) return;
      var u = nextUrl();
      if (!u) { list.dataset.endless = '0'; return; }
      loading = true;
      fetch(u, { credentials: 'same-origin' })
        .then(function (r) { if (!r.ok) throw new Error('http ' + r.status); return r.text(); })
        .then(function (html) {
          var doc = new DOMParser().parseFromString(html, 'text/html');
          var newList = doc.querySelector('product-list');
          var newNav = doc.querySelector(NAV_SEL);
          var added = 0;
          if (newList) {
            var kids = Array.prototype.slice.call(newList.children);
            for (var i = 0; i < kids.length; i++) {
              try {
                var node = document.importNode(kids[i], true);
                restoreReveal(node);
                list.appendChild(node);
                added++;
              } catch (e) {}
            }
            document.dispatchEvent(new CustomEvent('endless:appended', { detail: { count: added } }));
          }
          nav.innerHTML = newNav ? newNav.innerHTML : '';
          // keep going if user is still pinned at the bottom
          if (added > 0 && nearBottom()) { window.setTimeout(function () { tick(true); }, 150); }
        })
        .catch(function () { /* pagination stays visible */ })
        .then(function () { loading = false; });
    }

    var scheduled = false;
    window.addEventListener('scroll', function () {
      if (scheduled) return;
      scheduled = true;
      window.requestAnimationFrame(function () { scheduled = false; tick(false); });
    }, { passive: true });
    // safety net: poll periodically (cheap no-op when not near bottom)
    window.setInterval(function () { tick(false); }, 1200);
    tick(false);
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init);
  else init();
  document.addEventListener('facet:refetched', function () {
    var l = document.querySelector('product-list');
    if (l) l.dataset.endless = '';
    init();
  });
})();